var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.16669H17.5C17.721 4.16669 17.9329 4.25448 18.0892 4.41076C18.2455 4.56705 18.3333 4.77901 18.3333 5.00002V15.8334C18.3333 16.0544 18.2455 16.2663 18.0892 16.4226C17.9329 16.5789 17.721 16.6667 17.5 16.6667H7.49996M7.49996 4.16669H2.49996C2.27895 4.16669 2.06698 4.25448 1.9107 4.41076C1.75442 4.56705 1.66663 4.77901 1.66663 5.00002V15.8334C1.66663 16.0544 1.75442 16.2663 1.9107 16.4226C2.06698 16.5789 2.27895 16.6667 2.49996 16.6667H7.49996M7.49996 4.16669V16.6667",
    stroke: "#101828",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 7.08335V8.75002M15.4166 6.66669L10.4166 13.75",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 11.25C5.41667 10.7898 5.04357 10.4167 4.58333 10.4167C4.1231 10.4167 3.75 10.7898 3.75 11.25C3.75 11.7103 4.1231 12.0834 4.58333 12.0834C5.04357 12.0834 5.41667 11.7103 5.41667 11.25Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 13.75C5.41667 13.2898 5.04357 12.9167 4.58333 12.9167C4.1231 12.9167 3.75 13.2898 3.75 13.75C3.75 14.2103 4.1231 14.5834 4.58333 14.5834C5.04357 14.5834 5.41667 14.2103 5.41667 13.75Z",
    fill: "#101828"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/Plate.fdfafe8faab47407be6a8e685d8987ab.svg";
export { ForwardRef as ReactComponent };